var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.980957,
    width: 23.7913,
    height: 24.0381,
    rx: 11.8957,
    fill: "#92D050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8337 15.4746C16.8291 15.48 16.822 15.4854 16.8213 15.4915C16.7252 15.9162 16.3067 16.1281 15.8327 15.9208C15.3532 15.7111 14.8745 15.5007 14.3951 15.2903C13.6978 14.9847 12.9997 14.6822 12.3039 14.3735C12.0212 14.2483 11.7472 14.2514 11.4637 14.3765C10.2924 14.8941 9.11796 15.4063 7.94509 15.92C7.76939 15.9968 7.58745 16.0329 7.39848 15.9791C6.95729 15.8532 6.7933 15.3003 7.08847 14.9133C7.2423 14.7113 7.40551 14.514 7.5773 14.3266C8.81498 12.9759 10.0542 11.6267 11.2974 10.2806C11.6511 9.89819 12.1267 9.89973 12.4796 10.2821C13.7509 11.6613 15.0174 13.0442 16.2848 14.4272C16.398 14.5509 16.5097 14.6768 16.605 14.8135C16.6932 14.9394 16.7588 15.0799 16.8337 15.2143V15.4746Z",
    fill: "#92D050"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.30f7d73135eedf87b8971b8358940202.svg";
export { ForwardRef as ReactComponent };